import React from 'react'

import SearchBarForm from '../searchBar/searchBarForm'
import SearchBarInput from '../searchBar/searchBarInput'
import SearchIcon from '../icons/search'

const PageOffLeftSearchBar = ({ makeSearchLink }) => {
  return (
    <div className="off-canvas-left__search">
      <SearchBarForm makeSearchLink={makeSearchLink}>
        <div style={{ margin: 0, padding: 0, display: 'inline' }} />
        <div className="search-field -border-none">
          <div className="search-field__input">
            <SearchBarInput
              className="search-field__input-field"
              name="term"
              placeholder="Search"
            />
          </div>
          <button className="fds-c-button search-field__button" type="submit">
            <SearchIcon title="search" />
          </button>
        </div>
      </SearchBarForm>
    </div>
  )
}

export default PageOffLeftSearchBar
